import { defaultParseError, parseNumber } from "../utils";
export class WeekYear {
    render(date) {
        const tempDate = date.toLocalDate();
        tempDate.setDate(tempDate.getDate() + 3 - (tempDate.getDay() + 6) % 7);
        return String(tempDate.getFullYear());
    }
    parse(state) {
        return parseNumber(state, 1000, 9999, null, defaultParseError(state));
    }
    get displayHours() {
        return false;
    }
    get displayMinutes() {
        return false;
    }
    get displaySeconds() {
        return false;
    }
    get displayMilliseconds() {
        return false;
    }
    get displayMicroseconds() {
        return false;
    }
    get displayDate() {
        return true;
    }
    get displayMonth() {
        return true;
    }
    get displayYear() {
        return true;
    }
    get displayTimezone() {
        return false;
    }
}
//# sourceMappingURL=WeekYear.js.map
